import { getStore } from "../redux/storeRef";
import { enqueueErrorSnackbar } from "../redux/actions/snackbarActions";

export const IMPERSONATION_ERROR_MESSAGE =
  "This action is not allowed in impersonation mode";

export const blockIfImpersonating = () => {
  const store = getStore();
  if (!store) return false;

  const { userState } = store.getState();
  if (userState?.user?.isImpersonate) {
    store.dispatch(
      enqueueErrorSnackbar({ message: IMPERSONATION_ERROR_MESSAGE })
    );
    return true;
  }
  return false;
};
